import React from "react";
import { Link } from "react-router-dom";

import matchaLavaCakeMenu from "../../assets/images/resource/menu/dessert/matcha-lava-cake.webp";


function Rice() {
  return (
    <>
      <section className="menu-one">
        <div className="auto-container">
          <div className="title-box centered">
            <h2>Desserts</h2>
          </div>
          <div className="row clearfix">
            <div className="image-col col-lg-7 col-md-12 col-sm-12">
              <div className="inner">
                <div className="image"><img src={matchaLavaCakeMenu} alt="" /></div>
              </div>
            </div>
            
            <div className="menu-col col-lg-5 col-md-12 col-sm-12">
              <div className="inner">
                <div className="dish-block">
                  <div className="inner-box">
                    <div className="title clearfix"><div className="ttl clearfix"><h5><Link to="#">Matcha Lava Cake</Link></h5></div><div className="price"><span>$14</span></div></div>
                    <div className="text desc"><Link to="#">Dark chocolate cake with matcha ganache, green tea ice cream and cookie crumbs.</Link></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Rice;
